export function citySelect() {

    let city = document.querySelector('[am-city="header"]'),
        currentCity = document.querySelector('[am-current-city="header"]'),
        search = document.querySelector('[am-search]'),
        cityBlock = document.querySelector('[am-city-select="header"]'),
        cityItem,
        fixed = document.querySelector('[am-fixed]'),
        btnYes = document.querySelector('[am-yes="select"]'),
        btnNo = document.querySelector('[am-no="select"]'),
        burgerBtn = document.querySelector('[am-block="burger"]');

    /**
     * AJAX запрос
     * @param  {object} params Параметры, похожие на $.ajax
     */

    function httpGetAsync(params)
    {
        var _params = Object.assign({
            url: window.location.pathname,
            type: 'GET',
            data: null,
            dataType: 'JSON',
            success: function(){},
        }, params);

        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function() {
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                try {
                    var json = JSON.parse(xmlHttp.responseText);
                    _params.success(json);
                } catch (e) {

                }
            }
        }
        xmlHttp.open(_params.type, _params.url, true); // true for asynchronous
        xmlHttp.send(_params.data);
    }

    /**
     * Клик по списку городов
     */

    document.addEventListener('click', function(e) {
        if (e.target && e.target.closest('.js-loadCities')) {
            const el = e.target.closest('.js-loadCities');

            // от повторных кликов
            if (el.classList.contains('is-initialized')) {
                return false;
            }

            document.querySelectorAll('.js-loadCities').forEach( function(item) {
                item.classList.add('is-initialized');
            })

            let currentCity = document.querySelector('[am-current-city]').innerText,
                detectedCity = document.querySelector('.js-detectedCity') ? document.querySelector('.js-detectedCity').innerText : currentCity;

            httpGetAsync({
                url: '/cities/ajax_list',
                type: 'GET',
                data: {},
                dataType: 'JSON',
                success: function(r) {
                    if (r.status == 'ok') {

                        var target = document.getElementById(el.dataset.block);
                        r.cities_list.forEach(function(item) {
                            // от городов с пустым title
                            if (item.title == null) {
                                return false;
                            }

                            const li = document.createElement('li');
                            if (item.title != detectedCity.split(' ').join('') && window.innerWidth < 999) {
                                li.classList.add('is-hidden');
                            }

                            li.dataset.link = item.url;
                            li.setAttribute('am-city-item','header');
                            li.innerText = item.title;
                            target.appendChild(li);

                            if (item.title.split(' ').join('') == currentCity.split(' ').join('')) {
                                li.classList.add('is-active');
                            }

                            li.addEventListener('click', function() {
                                let link = li.dataset.link;
                                location.href = link;
                            });

                            cityItem = document.querySelectorAll('[am-city-item="header"]');
                        });

                        target.classList.add('is-initialized');
                    }
                }
            });
        }
    });

    /**
     * Города на странице контакты
     */
    Array.from(document.querySelectorAll('.js-citiesWrapper')).forEach(function(el) {
        httpGetAsync({
            url: '/cities/ajax_list',
            type: 'GET',
            data: {},
            dataType: 'JSON',
            success: function(r) {
                if (r.status == 'ok') {
                    var target = document.querySelector('.js-citiesWrapper');
                    r.cities_list.forEach(function(item) {
                        const li = document.createElement('li');
                        li.dataset.link = item.url;
                        li.setAttribute('am-item','consultation');
                        li.innerText = item.title;
                        target.appendChild(li);

                        li.addEventListener('click', function() {
                            let link = li.dataset.link;
                            location.href = link;
                        });
                    });

                    target.classList.add('is-initialized');
                }
            }
        });
    });

    if ( window.innerWidth > 999) {

        let cityList = document.querySelector('[am-city-list="header"]'),
            notFoundCities = document.querySelector('.js-cityNotFound');

        city.addEventListener('click', function() {
            city.classList.add('is-active');
            cityBlock.classList.add('is-active');
            search.focus();
            if (window.pageYOffset >= 40) {
                fixed.classList.add('nav-hidden');
            }
        });

        city.addEventListener('mouseleave', function() {
            city.classList.remove('is-active');
            cityBlock.classList.remove('is-active');
        });

        search.addEventListener('input', () => {
            const searchText = new RegExp(search.value.trim(), 'i');
            cityItem.forEach( function(item) {
                if (!searchText.test(item.textContent)) {
                    item.classList.add('is-hidden')
                } else {
                    item.classList.remove('is-hidden')
                }

                let cityCounter = cityList.querySelectorAll('li').length - cityList.querySelectorAll('.is-hidden').length;
                cityBlock.style.width = `calc( 200px * ${Math.ceil(cityCounter / 11) + 1})`;

                if (cityItem.length == cityList.querySelectorAll('.is-hidden').length) {
                    notFoundCities.classList.add('is-active');
                } else {
                    notFoundCities.classList.remove('is-active');
                }
            });
        });

        search.addEventListener('change', function() {
            cityItem.forEach( function(item) {
                let visibleItem = cityItem.length - cityList.querySelectorAll('.is-hidden').length;
                if (visibleItem == 1  && !item.classList.contains('is-hidden')) {
                    location.href = item.dataset.link;
                }
            });
        });

    } else {

        let cityBtn = document.querySelector('[data-city-mob]'),
            cityBlock = document.querySelector('[data-city]'),
            search = document.querySelector('[am-city-search="burger"]'),
            cityList = document.querySelector('[am-city-list="burger"]'),
            notFoundCities = document.querySelector('.js-cityNotFoundMob'),
            currentCity = document.querySelectorAll('[am-current-city="burger"]');

        cityBtn.addEventListener('click', function() {
            cityBlock.classList.add('is-active');
            search.focus();
        });

        search.addEventListener('input', () => {
            const currentCity = document.querySelector('[am-current-city]').innerText;
            const detectedCity = document.querySelector('.js-detectedCity') ? document.querySelector('.js-detectedCity').innerText : currentCity;
            const autoCityCheck = document.querySelector('[am-block="checkCity"]');
            if (autoCityCheck && autoCityCheck.classList.contains('is-active')) {
                autoCityCheck.classList.remove('is-active');
            }

            const searchText = new RegExp(search.value.trim(), 'i');
            cityItem.forEach( function(item) {

                if (!searchText.test(item.textContent)) {
                    item.classList.add('is-hidden');
                } else {
                    item.classList.remove('is-hidden');
                }

                if (item.innerText != detectedCity.split(' ').join('') && search.value.split(' ').join('') == '') {
                    item.classList.add('is-hidden');
                }

            });

            if (cityItem.length == cityList.querySelectorAll('.is-hidden').length) {
                notFoundCities.classList.add('is-active');
            } else {
                notFoundCities.classList.remove('is-active');
            }
        });

        search.addEventListener('change', function() {
            cityItem.forEach( function(item) {
                let visibleItem = cityItem.length - cityList.querySelectorAll('.is-hidden').length;
                if (visibleItem == 1  && !item.classList.contains('is-hidden')) {
                    location.href = item.dataset.link;
                }
            });
        });
    }
}

